// import React, { lazy, Suspense } from 'react';
// import "./App.css";
// import { Routes, Route, BrowserRouter } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// // import Sidebar from './components/Sidebar';
// import Sidebar from './components/toast/Sidebar';
// import Loader from './components/Loader';

// // Lazy load components
// const Overview = lazy(() => import('./components/Overview'));
// const Settings = lazy(() => import('./pages/settings/Settings'));
// const ChangePassword = lazy(() => import('./pages/settings/ChangePassword'));
// const Country = lazy(() => import('./pages/settings/Country'));
// const Region = lazy(() => import('./pages/settings/Region'));
// const Query = lazy(() => import('./pages/settings/Query'));
// const City = lazy(() => import('./pages/settings/City'));
// const FinancialYear = lazy(() => import('./pages/settings/FinancialYear'));
// const BuiltyForm = lazy(() => import('./pages/distribution/BuiltyForm'));
// const OrderBooking = lazy(() => import('./pages/distribution/OrderBooking'));
// const BookingOrder = lazy(() => import('./pages/distribution/BookingOrder'));
// const LoadSummary = lazy(() => import('./pages/distribution/LoadSummary'));
// const ProductTypes = lazy(() => import('./pages/product/ProductTypes'));
// const BrandName = lazy(() => import('./pages/product/BrandName'));
// const CategoryName = lazy(() => import('./pages/product/CategoryName'));
// const SubCategory = lazy(() => import('./pages/product/SubCategory'));
// const Units = lazy(() => import('./pages/product/Units'));
// const Product = lazy(() => import('./pages/product/Product'));
// const PurchaseOrder = lazy(() => import('./pages/purchase/PurchaseOrder'));
// const Vendor = lazy(() => import('./pages/setup/Vendor'));
// const Warehouse = lazy(() => import('./pages/setup/Warehouse'));
// const ViewProducts = lazy(() => import('./pages/product/ViewProducts'));
// const AddPurchase = lazy(() => import('./pages/purchase/AddPurchase'));
// const PurchaseInvoice = lazy(() => import('./pages/purchase/PurchaseInvoice'));
// const Inventory = lazy(() => import('./pages/Inventory/Inventory'));
// const StockValue = lazy(() => import('./pages/stocks/StockValue'));
// const StockAdjustment = lazy(() => import('./pages/stocks/StockAdjustment'));
// const Customers = lazy(() => import('./pages/setup/Customers'));
// const Orders = lazy(() => import('./pages/distribution/Orders'));
// const PurchasePayment = lazy(() => import('./pages/payments/PurchasePayment'));
// const StaffCategory = lazy(() => import('./pages/setup/StaffCategory'));
// const Staff = lazy(() => import('./pages/setup/Staff'));
// const StaffView = lazy(() => import('./pages/setup/StaffView'));
// const StaffCategoryView = lazy(() => import('./pages/setup/StaffCategoryView'));
// const VendorView = lazy(() => import('./pages/setup/VendorView'));
// const CustomerCategory = lazy(() => import('./pages/setup/CustomerCategory'));
// const CustomerCategoryView = lazy(() => import('./pages/setup/CustomerCategoryView'));
// const AddTown = lazy(() => import('./pages/setup/AddTown'));
// const TownsView = lazy(() => import('./pages/setup/TownsView'));
// const WarehouseView = lazy(() => import('./pages/setup/WarehouseView'));
// const AddZone = lazy(() => import('./pages/setup/AddZone'));
// const ZoneView = lazy(() => import('./pages/setup/ZoneView'));
// const AddSaleman = lazy(() => import('./pages/setup/AddSaleman'));
// const SalemanView = lazy(() => import('./pages/setup/SalemanView'));
// const CustomersView = lazy(() => import('./pages/setup/CustomersView'));
// const RecieveVoucher = lazy(() => import('./pages/payments/RecieveVoucher'));
// const JournalPayment = lazy(() => import('./pages/payments/JournalPayment'));
// const JournalPaymentView = lazy(() => import('./pages/payments/JournalPaymentView'));
// const AddPattyCategory = lazy(() => import('./pages/setup/AddPattyCategory'));
// const PattyCategoryView = lazy(() => import('./pages/setup/PattyCategoryView'));
// const PattyPayment = lazy(() => import('./pages/payments/PattyPayment'));
// const PattyExpenceView = lazy(() => import('./pages/payments/PattyExpenceView'));
// const PurchaseReturn = lazy(() => import('./pages/purchase/PurchaseReturn'));
// const PurchaseReturnView = lazy(() => import('./pages/purchase/PurchaseReturnView'));
// const OrderReturn = lazy(() => import('./pages/distribution/OrderReturn'));
// const OrderReturnView = lazy(() => import('./pages/distribution/OrderReturnView'));
// const Index = lazy(() => import("./pages/distribution/bookingOrders/Index"));
// const PurchaseOrdersView = lazy(() => import('./pages/purchase/PurchaseOrdersView'));
// const PaymentVoucher = lazy(() => import('./pages/payments/PaymentVoucher'));
// const SaleInvoice = lazy(() => import('./pages/distribution/SaleInvoice'));
// const GstType = lazy(() => import('./pages/setup/GstType'));
// const AdvanceTax = lazy(() => import('./pages/setup/AdvanceTax'));
// const SaleInvoiceView = lazy(() => import('./pages/distribution/SaleInvoiceView'));
// const ReceivePaymentsView = lazy(() => import('./pages/payments/ReceivePaymentsView'));
// const PurchaseInvoiceView = lazy(() => import('./pages/purchase/PurchaseInvoiceView'));
// const PurchasePaymentView = lazy(() => import('./pages/payments/PurchasePaymentView'));
// const PurchaseInvoiceReturn = lazy(() => import('./pages/purchase/PurchaseInvoiceReturn'));
// const PackType = lazy(() => import('./pages/product/PackType'));
// const ChartOfAccounts = lazy(() => import('./pages/accounts/ChartOfAccounts'));
// const Login = lazy(() => import('./pages/user/Login'));
// const Register = lazy(() => import('./pages/user/Register'));

// // reports
// const LoadSheetReport = lazy(() => import('./pages/reports/LoadSheetReport'));
// const SaleNPurchaseReport = lazy(() => import('./pages/reports/SaleNPurchaseReport'));
// const StockLedgerReport = lazy(() => import('./pages/reports/StockLedgerReport'));
// const CustomerReport = lazy(() => import('./pages/reports/CustomerReport'));
// const ItemListReport = lazy(() => import('./pages/reports/ItemListReport'));
// const LastPurchaseSaleReport = lazy(() => import('./pages/reports/LastPurchaseSaleReport'));
// const DailyStockReport = lazy(() => import('./pages/reports/DailyStockReport'));
// const ProductWiseSale = lazy(() => import('./pages/reports/ProductWiseSale'));
// const StockPosition = lazy(() => import('./pages/reports/StockPosition'));
// const GrossProfitReport = lazy(() => import('./pages/reports/GrossProfitReport'));
// const AllSaleInvoices = lazy(() => import('./pages/reports/AllSaleInvoices'));
// const YearlyExpenses = lazy(() => import('./pages/reports/YearlyExpenses'));
// const MaxSaleProduct = lazy(() => import('./pages/reports/MaxSaleProduct'));
// const UnsoldProducts = lazy(() => import('./pages/reports/UnsoldProducts'));
// const DailySalesReport = lazy(() => import('./pages/reports/DailySalesReport'));
// const AgingReceiveableReport = lazy(() => import('./pages/reports/AgingReceiveableReport'));
// const AgingPayableReport = lazy(() => import('./pages/reports/AgingPayableReport'));
// const AccountLedgerReport = lazy(() => import('./pages/reports/AccountLedgerReport'));
// const OutstandingReport = lazy(() => import('./pages/reports/OutstandingReport'));
// const PDCReport = lazy(() => import('./pages/reports/PDCReport'));
// const DailyTransactionReport = lazy(() => import('./pages/reports/DailyTransactionReport'));
// const TrialBalanceReport = lazy(() => import('./pages/reports/TrialBalanceReport'));



// // Group routes by category
// const settingsRoutes = [
//   { path: "/changepassword", Component: ChangePassword },
//   { path: "/settings", Component: Settings },
//   { path: "/users", Component: lazy(() => import('./components/Users')) },
//   { path: "/country", Component: Country },
//   { path: "/region", Component: Region },
//   { path: "/city", Component: City },
//   { path: "/financialyear", Component: FinancialYear },
//   { path: "/query", Component: Query },
// ];

// const distributionRoutes = [
//   { path: "/builtyform", Component: BuiltyForm },
//   { path: "/orderbooking", Component: BookingOrder },
//   { path: "/loadsummary", Component: LoadSummary },
//   { path: "/orders", Component: Orders },
//   { path: "/order-return", Component: OrderReturn },
//   { path: "/order-return-view", Component: OrderReturnView },
//   { path: "/sale-invoice", Component: SaleInvoice },
//   { path: "/sale-invoice-view", Component: SaleInvoiceView },
// ];

// const productRoutes = [
//   { path: "/product-type", Component: ProductTypes },
//   { path: "/add-brand", Component: BrandName },
//   { path: "/add-category", Component: CategoryName },
//   { path: "/add-subcategory", Component: SubCategory },
//   { path: "/add-unit", Component: Units },
//   { path: "/add-product", Component: Product },
//   { path: "/product", Component: ViewProducts },
//   { path: "/scan", Component: lazy(() => import('./components/ScanBarcode')) },
//   { path: "/packtype", Component: PackType },
// ];

// const setupRoutes = [
//   { path: "/vendor", Component: Vendor },
//   { path: "/warehouse", Component: Warehouse },
//   { path: "/customers", Component: Customers },
//   { path: "/staff-category", Component: StaffCategory },
//   { path: "/add-staff", Component: Staff },
//   { path: "/staff-view", Component: StaffView },
//   { path: "/vendor-view", Component: VendorView },
//   { path: "/staff-view-category", Component: StaffCategoryView },
//   { path: "/add-customer-category", Component: CustomerCategory },
//   { path: "/customer-view-category", Component: CustomerCategoryView },
//   { path: "/add-town", Component: AddTown },
//   { path: "/add-zone", Component: AddZone },
//   { path: "/town-view", Component: TownsView },
//   { path: "/zone-view", Component: ZoneView },
//   { path: "/warehouse-view", Component: WarehouseView },
//   { path: "/saleman-view", Component: SalemanView },
//   { path: "/add-saleman", Component: AddSaleman },
//   { path: "/customers-view", Component: CustomersView },
//   { path: "/add-patty-category", Component: AddPattyCategory },
//   { path: "/patty-category-view", Component: PattyCategoryView },
//   { path: "/gst-type", Component: GstType },
//   { path: "/advance-tax", Component: AdvanceTax },
// ];

// const purchaseRoutes = [
//   { path: "/purchase-order", Component: PurchaseOrder },
//   { path: "/add-purchase", Component: AddPurchase },
//   { path: "/purchase-invoice", Component: PurchaseInvoice },
//   { path: "/purchase-return", Component: PurchaseInvoiceReturn },
//   { path: "/purchase-return-view", Component: PurchaseReturnView },
//   { path: "/purchase-orders-view", Component: PurchaseOrdersView },
//   { path: "/purchase-invoice-view", Component: PurchaseInvoiceView },
// ];

// const inventoryRoutes = [
//   { path: "/get-inventory", Component: Inventory },
// ];

// const stocksRoutes = [
//   { path: "/stockvalue", Component: StockValue },
//   { path: "/stockadjustment", Component: StockAdjustment },
// ];

// const orderBookingRoutes = [
//   { path: "/orderbooking", Component: OrderBooking },
// ];

// const paymentsRoutes = [
//   { path: "/payment-voucher", Component: PaymentVoucher },
//   { path: "/recieve-voucher", Component: RecieveVoucher },
//   { path: "/journal-payment", Component: JournalPayment },
//   { path: "/patty-payment", Component: PattyPayment },
//   { path: "/journal-payment-view", Component: JournalPaymentView },
//   { path: "/patty-payment-view", Component: PattyExpenceView },
//   { path: "/receive-payment-view", Component: ReceivePaymentsView },
//   { path: "/purchase-payment-view", Component: PurchasePaymentView },
//   { path: "/journal-payment-view", Component: JournalPaymentView },
// ];

// const accountsRoutes = [
//   { path: "/chart-of-accounts", Component: ChartOfAccounts },
//   // Add other account-related routes here
// ];

// const userRoutes = [
//   { path: "/login", Component: Login },
//   { path: "/register", Component: Register },
// ];
// const ReportsRoutes = [
//   { path: "/loadsheet", Component: LoadSheetReport },
//   { path: "/sale-n-purchase", Component: SaleNPurchaseReport },
//   { path: "/stockledger", Component: StockLedgerReport },
//   { path: "/customerreport", Component: CustomerReport },
//   { path: "/itemlist", Component: ItemListReport },
//   { path: "/last-purchase-sale", Component: LastPurchaseSaleReport },
//   { path: "/daily-stock", Component: DailyStockReport },
//   { path: "/product-wise-sale", Component: ProductWiseSale },
//   { path: "/stock-position", Component: StockPosition },
//   { path: "/gross-profit-report", Component: GrossProfitReport },
//   { path: "/all-sale-invoices", Component: AllSaleInvoices },
//   { path: "/yearly-expenses", Component: YearlyExpenses },
//   { path: "/max-sale-product", Component: MaxSaleProduct },
//   { path: "/unsold-products", Component: UnsoldProducts },
//   { path: "/daily-sales", Component: DailySalesReport },
//   { path: "/aging-receiveable", Component: AgingReceiveableReport },
//   { path: "/aging-payable", Component: AgingPayableReport },
//   { path: "/account-ledger", Component: AccountLedgerReport },
//   { path: "/outstanding-report", Component: OutstandingReport },
//   { path: "/pdc-report", Component: PDCReport },
//   { path: "/transaction-report", Component: DailyTransactionReport },
//   { path: "/trial-balance", Component: TrialBalanceReport },

// ];

// const renderRoutes = (routes) => {
//   return routes.map(({ path, Component }) => (
//     <Route
//       key={path}
//       path={path}
//       element={
//         <Suspense fallback={<LoadingFallback />}>
//           <Component />
//         </Suspense>
//       }
//     />
//   ));
// };

// const LoadingFallback = () => (
//   <div className="w-full h-screen flex justify-center items-center">
//     <Loader />
//   </div>
// );

// const App = () => {
//   const { modes, sideBarCollapes } = useSelector((state) => state.mode);

//   React.useEffect(() => {
//     document.body.style.backgroundColor = modes === "dark" ? "#222222" : "#EDEDED";
//   }, [modes]);

//   return (

//     <BrowserRouter>
//       <main className={`w-full bg-transparent transition-all duration-150 ease-linear flex`}>
//         <div className='w-full'>
//           <div className='sidebar fixed top-0 left-0 z-50'>
//             {/* <Sidebar /> */}
//             <Sidebar/>
//           </div>
//           <div className={`container mx-auto content transition-all duration-150 ease-linear w-full ${sideBarCollapes === "show" ? "md:pl-[13.8rem]" : "md:pl-[4.8rem]"}`}>
//             <Suspense fallback={<LoadingFallback />}>
//               <Routes>
//                 <Route path="/" element={<Overview />} />
//                 {renderRoutes(settingsRoutes)}
//                 {renderRoutes(distributionRoutes)}
//                 {renderRoutes(productRoutes)}
//                 {renderRoutes(setupRoutes)}
//                 {renderRoutes(purchaseRoutes)}
//                 {renderRoutes(inventoryRoutes)}
//                 {renderRoutes(stocksRoutes)}
//                 {renderRoutes(orderBookingRoutes)}
//                 {renderRoutes(paymentsRoutes)}
//                 {renderRoutes(accountsRoutes)}
//                 {renderRoutes(userRoutes)}
//                 {renderRoutes(ReportsRoutes)}
//               </Routes>
//             </Suspense>
//           </div>
//         </div>
//         {/* <PhoneMenu /> */}
//       </main>
//     </BrowserRouter>



//   );
// };

// export default App;


import React, { lazy, Suspense, useEffect } from 'react';
import './App.css';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from './components/toast/Sidebar';
import VoucherPrint from './pages/payments/VoucherPrint';
import Loader from './components/Loader';
import { useGetCompanyQuery } from './redux/features/apiSlices/setup/company';
// import UrlProtectedRoute from './components/toast/UrlProtectedRoutes';

// Lazy load components
const Overview = lazy(() => import('./components/Overview'));
const Login = lazy(() => import('./pages/user/Login'));
const Register = lazy(() => import('./pages/user/Register'));
const Settings = lazy(() => import('./pages/settings/Settings'));
const ChangePassword = lazy(() => import('./pages/settings/ChangePassword'));
const Country = lazy(() => import('./pages/settings/Country'));
const Region = lazy(() => import('./pages/settings/Region'));
const Query = lazy(() => import('./pages/settings/Query'));
const City = lazy(() => import('./pages/settings/City'));
const FinancialYear = lazy(() => import('./pages/settings/FinancialYear'));
const BuiltyForm = lazy(() => import('./pages/distribution/BuiltyForm'));
const OrderBooking = lazy(() => import('./pages/distribution/OrderBooking'));
const BookingOrder = lazy(() => import('./pages/distribution/BookingOrder'));
const LoadSummary = lazy(() => import('./pages/distribution/LoadSummary'));
const ProductTypes = lazy(() => import('./pages/product/ProductTypes'));
const BrandName = lazy(() => import('./pages/product/BrandName'));
const CategoryName = lazy(() => import('./pages/product/CategoryName'));
const SubCategory = lazy(() => import('./pages/product/SubCategory'));
const Units = lazy(() => import('./pages/product/Units'));
const Product = lazy(() => import('./pages/product/Product'));
const PurchaseOrder = lazy(() => import('./pages/purchase/PurchaseOrder'));
const Vendor = lazy(() => import('./pages/setup/Vendor'));
const Warehouse = lazy(() => import('./pages/setup/Warehouse'));
const ViewProducts = lazy(() => import('./pages/product/ViewProducts'));
const AddPurchase = lazy(() => import('./pages/purchase/AddPurchase'));
const PurchaseInvoice = lazy(() => import('./pages/purchase/PurchaseInvoice'));
const Inventory = lazy(() => import('./pages/Inventory/Inventory'));
const StockValue = lazy(() => import('./pages/stocks/StockValue'));
const StockAdjustment = lazy(() => import('./pages/stocks/StockAdjustment'));
const Customers = lazy(() => import('./pages/setup/Customers'));
const Orders = lazy(() => import('./pages/distribution/Orders'));
const PurchasePayment = lazy(() => import('./pages/payments/PurchasePayment'));
const StaffCategory = lazy(() => import('./pages/setup/StaffCategory'));
const Staff = lazy(() => import('./pages/setup/Staff'));
const StaffView = lazy(() => import('./pages/setup/StaffView'));
const StaffCategoryView = lazy(() => import('./pages/setup/StaffCategoryView'));
const VendorView = lazy(() => import('./pages/setup/VendorView'));
const CustomerCategory = lazy(() => import('./pages/setup/CustomerCategory'));
const CustomerCategoryView = lazy(() => import('./pages/setup/CustomerCategoryView'));
const AddTown = lazy(() => import('./pages/setup/AddTown'));
const TownsView = lazy(() => import('./pages/setup/TownsView'));
const WarehouseView = lazy(() => import('./pages/setup/WarehouseView'));
const AddZone = lazy(() => import('./pages/setup/AddZone'));
const ZoneView = lazy(() => import('./pages/setup/ZoneView'));
const AddSaleman = lazy(() => import('./pages/setup/AddSaleman'));
const SalemanView = lazy(() => import('./pages/setup/SalemanView'));
const CustomersView = lazy(() => import('./pages/setup/CustomersView'));
const RecieveVoucher = lazy(() => import('./pages/payments/RecieveVoucher'));
const JournalPayment = lazy(() => import('./pages/payments/JournalPayment'));
const JournalPaymentView = lazy(() => import('./pages/payments/JournalPaymentView'));
const AddPattyCategory = lazy(() => import('./pages/setup/AddPattyCategory'));
const PattyCategoryView = lazy(() => import('./pages/setup/PattyCategoryView'));
const PattyPayment = lazy(() => import('./pages/payments/PattyPayment'));
const PattyExpenceView = lazy(() => import('./pages/payments/PattyExpenceView'));
const PurchaseReturn = lazy(() => import('./pages/purchase/PurchaseReturn'));
const PurchaseReturnView = lazy(() => import('./pages/purchase/PurchaseReturnView'));
const SaleReturn = lazy(() => import('./pages/distribution/SaleReturn'));
const SaleReturnView = lazy(() => import('./pages/distribution/SaleReturnView'));
const Index = lazy(() => import('./pages/distribution/bookingOrders/Index'));
const PurchaseOrdersView = lazy(() => import('./pages/purchase/PurchaseOrdersView'));
const PaymentVoucher = lazy(() => import('./pages/payments/PaymentVoucher'));
const SaleInvoice = lazy(() => import('./pages/distribution/SaleInvoice'));
const GstType = lazy(() => import('./pages/setup/GstType'));
const ScheduleType = lazy(() => import('./pages/setup/ScheduleType'));
const AdvanceTax = lazy(() => import('./pages/setup/AdvanceTax'));
const SaleInvoiceView = lazy(() => import('./pages/distribution/SaleInvoiceView'));
const ReceivePaymentsView = lazy(() => import('./pages/payments/ReceivePaymentsView'));
const PurchaseInvoiceView = lazy(() => import('./pages/purchase/PurchaseInvoiceView'));
const PurchasePaymentView = lazy(() => import('./pages/payments/PurchasePaymentView'));
const PurchaseInvoiceReturn = lazy(() => import('./pages/purchase/PurchaseInvoiceReturn'));
const PackType = lazy(() => import('./pages/product/PackType'));
const ChartOfAccounts = lazy(() => import('./pages/accounts/ChartOfAccounts'));




const RoleAndPermissions = lazy(() => import('./pages/user/RoleAndPermissions'));



// Reports
const LoadSheetReport = lazy(() => import('./pages/reports/LoadSheetReport'));
const SaleNPurchaseReport = lazy(() => import('./pages/reports/SaleNPurchaseReport'));
const StockLedgerReport = lazy(() => import('./pages/reports/StockLedgerReport'));
const CustomerReport = lazy(() => import('./pages/reports/CustomerReport'));
const ItemListReport = lazy(() => import('./pages/reports/ItemListReport'));
const LastPurchaseSaleReport = lazy(() => import('./pages/reports/LastPurchaseSaleReport'));
const DailyStockReport = lazy(() => import('./pages/reports/DailyStockReport'));
const ProductWiseSale = lazy(() => import('./pages/reports/ProductWiseSale'));
const StockPosition = lazy(() => import('./pages/reports/StockPosition'));
const GrossProfitReport = lazy(() => import('./pages/reports/GrossProfitReport'));
const AllSaleInvoices = lazy(() => import('./pages/reports/AllSaleInvoices'));
const YearlyExpenses = lazy(() => import('./pages/reports/YearlyExpenses'));
const MaxSaleProduct = lazy(() => import('./pages/reports/MaxSaleProduct'));
const UnsoldProducts = lazy(() => import('./pages/reports/UnsoldProducts'));
const DailySalesReport = lazy(() => import('./pages/reports/DailySalesReport'));
const AgingReceiveableReport = lazy(() => import('./pages/reports/AgingReceiveableReport'));
const AgingPayableReport = lazy(() => import('./pages/reports/AgingPayableReport'));
const AccountLedgerReport = lazy(() => import('./pages/reports/AccountLedgerReport'));
const OutstandingReport = lazy(() => import('./pages/reports/OutstandingReport'));
const PDCReport = lazy(() => import('./pages/reports/PDCReport'));
const DailyTransactionReport = lazy(() => import('./pages/reports/DailyTransactionReport'));
const TrialBalanceReport = lazy(() => import('./pages/reports/TrialBalanceReport'));
const NotAuthorized = lazy(() => import('./pages/user/NotAuthorized'));
const BankAccount = lazy(() => import('./pages/setup/BankAccount'));
const CompanySetup = lazy(() => import('./pages/setup/CompanySetup'));
const InvoiceNoGen = lazy(() => import('./pages/setup/InvoiceNoGen'));
const Quotation = lazy(() => import('./pages/distribution/Quotation'));
const ViewQuotations = lazy(() => import('./pages/distribution/QuotationView'));
const DeliveryChallan = lazy(() => import('./pages/distribution/DeliveryChallan'));
const DeliveryChallanView = lazy(() => import('./pages/distribution/DeliveryChallanView'));
const CompanyView = lazy(() => import('./pages/setup/CompanyView'));
const FbrHsCode = lazy(() => import('./pages/setup/FbrHsCode'));







// Group routes by category
const settingsRoutes = [
  { path: '/changepassword', Component: ChangePassword },
  { path: '/settings', Component: Settings },
  { path: '/users', Component: lazy(() => import('./pages/settings/Users')) },
  { path: '/country', Component: Country },
  { path: '/region', Component: Region },
  { path: '/city', Component: City },
  { path: '/financialyear', Component: FinancialYear },
  { path: '/query', Component: Query },
  { path: '/register', Component: Register },
  { path: '/role-permission', Component: RoleAndPermissions },
  { path: '/company-setup', Component: CompanySetup },
  { path: '/company-view', Component: CompanyView },
  { path: '/not-authorized', Component: NotAuthorized },
];

const distributionRoutes = [
  { path: '/builtyform', Component: BuiltyForm },
  { path: '/orderbooking', Component: BookingOrder },
  { path: '/loadsummary', Component: LoadSummary },
  { path: '/orders', Component: Orders },
  { path: '/sale-return', Component: SaleReturn },
  { path: '/sale-return-view', Component: SaleReturnView },
  { path: '/sale-invoice', Component: SaleInvoice },
  { path: '/sale-invoice-view', Component: SaleInvoiceView },
  { path: '/quotation', Component: Quotation },
  { path: '/quotation-view', Component: ViewQuotations },
  { path: '/delivery-challan', Component: DeliveryChallan },
  { path: '/delivery-challan-view', Component: DeliveryChallanView },
];

const productRoutes = [
  { path: '/product-type', Component: ProductTypes },
  { path: '/add-brand', Component: BrandName },
  { path: '/add-category', Component: CategoryName },
  { path: '/add-subcategory', Component: SubCategory },
  { path: '/add-unit', Component: Units },
  { path: '/add-product', Component: Product },
  { path: '/product', Component: ViewProducts },
  { path: '/scan', Component: lazy(() => import('./components/ScanBarcode')) },
  { path: '/packtype', Component: PackType },
];

const setupRoutes = [
  { path: '/vendor', Component: Vendor },
  { path: '/warehouse', Component: Warehouse },
  { path: '/customers', Component: Customers },
  { path: '/staff-category', Component: StaffCategory },
  { path: '/add-staff', Component: Staff },
  { path: '/staff-view', Component: StaffView },
  { path: '/vendor-view', Component: VendorView },
  { path: '/staff-view-category', Component: StaffCategoryView },
  { path: '/add-customer-category', Component: CustomerCategory },
  { path: '/customer-view-category', Component: CustomerCategoryView },
  { path: '/add-town', Component: AddTown },
  { path: '/add-zone', Component: AddZone },
  { path: '/town-view', Component: TownsView },
  { path: '/zone-view', Component: ZoneView },
  { path: '/warehouse-view', Component: WarehouseView },
  { path: '/saleman-view', Component: SalemanView },
  { path: '/add-saleman', Component: AddSaleman },
  { path: '/customers-view', Component: CustomersView },
  { path: '/add-patty-category', Component: AddPattyCategory },
  { path: '/patty-category-view', Component: PattyCategoryView },
  { path: '/gst-type', Component: GstType },
  { path: '/advance-tax', Component: AdvanceTax },
  { path: '/schedule-type', Component: ScheduleType },
  { path: '/invoice-no-gen', Component: InvoiceNoGen },
  { path: '/bank-account', Component: BankAccount },
  { path: '/fbr-hscode', Component: FbrHsCode },
];


const purchaseRoutes = [
  { path: '/purchase-order', Component: PurchaseOrder },
  { path: '/add-purchase', Component: AddPurchase },
  { path: '/purchase-invoice', Component: PurchaseInvoice },
  { path: '/purchase-return', Component: PurchaseInvoiceReturn },
  { path: '/purchase-return-view', Component: PurchaseReturnView },
  { path: '/purchase-orders-view', Component: PurchaseOrdersView },
  { path: '/purchase-invoice-view', Component: PurchaseInvoiceView },
];

const inventoryRoutes = [
  { path: '/get-inventory', Component: Inventory },
];

const stocksRoutes = [
  { path: '/stockvalue', Component: StockValue },
  { path: '/stockadjustment', Component: StockAdjustment },
];

const orderBookingRoutes = [
  { path: '/orderbooking', Component: OrderBooking },
];

const paymentsRoutes = [
  { path: '/payment-voucher', Component: PaymentVoucher },
  { path: '/recieve-voucher', Component: RecieveVoucher },
  { path: '/journal-payment', Component: JournalPayment },
  { path: '/patty-payment', Component: PattyPayment },
  { path: '/journal-payment-view', Component: JournalPaymentView },
  { path: '/patty-payment-view', Component: PattyExpenceView },
  { path: '/receive-payment-view', Component: ReceivePaymentsView },
  { path: '/purchase-payment-view', Component: PurchasePaymentView },
  { path: '/print-voucher', Component: VoucherPrint },
];


const accountsRoutes = [
  { path: '/chart-of-accounts', Component: ChartOfAccounts },
];

const reportsRoutes = [
  { path: '/loadsheet', Component: LoadSheetReport },
  { path: '/sale-n-purchase', Component: SaleNPurchaseReport },
  { path: '/stockledger', Component: StockLedgerReport },
  { path: '/customerreport', Component: CustomerReport },
  { path: '/itemlist', Component: ItemListReport },
  { path: '/last-purchase-sale', Component: LastPurchaseSaleReport },
  { path: '/daily-stock', Component: DailyStockReport },
  { path: '/product-wise-sale', Component: ProductWiseSale },
  { path: '/stock-position', Component: StockPosition },
  { path: '/gross-profit-report', Component: GrossProfitReport },
  { path: '/all-sale-invoices', Component: AllSaleInvoices },
  { path: '/yearly-expenses', Component: YearlyExpenses },
  { path: '/max-sale-product', Component: MaxSaleProduct },
  { path: '/unsold-products', Component: UnsoldProducts },
  { path: '/daily-sales', Component: DailySalesReport },
  { path: '/aging-receiveable', Component: AgingReceiveableReport },
  { path: '/aging-payable', Component: AgingPayableReport },
  { path: '/account-ledger', Component: AccountLedgerReport },
  { path: '/outstanding-report', Component: OutstandingReport },
  { path: '/pdc-report', Component: PDCReport },
  { path: '/transaction-report', Component: DailyTransactionReport },
  { path: '/trial-balance', Component: TrialBalanceReport },
];

const renderRoutes = (routes) => {
  return routes.map(({ path, Component }) => (
    <Route
      key={path}
      path={path}
      element={
        <Suspense fallback={<LoadingFallback />}>
          <Component />
        </Suspense>
      }
    />
  ));
};

const LoadingFallback = () => (
  <div className="w-full h-screen flex justify-center items-center">
    <Loader />
  </div>
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.user);
  const token = localStorage.getItem("token");

  return token ? children : <Navigate to="/login" />;
};

const App = () => {
  const { modes, sideBarCollapes, phoneToggle, printData } = useSelector((state) => state.mode);
  const token = localStorage.getItem("token");
  const { isAuthenticated } = useSelector((state) => state.user); // Get auth status


  function autoRemoveExpiredToken() {
    const expiry = localStorage.getItem("token_expiry");
    if (!expiry) return;

    const now = new Date().getTime();

    if (now > parseInt(expiry)) {
      localStorage.removeItem("token");
      localStorage.removeItem("token_expiry");
    }
  }
  useEffect(() => {
    autoRemoveExpiredToken();
  }, []);
  useEffect(() => {
    console.log(phoneToggle)
  }, [phoneToggle]);

  useEffect(() => {
    const interval = setInterval(autoRemoveExpiredToken, 100000); // 1 min
    return () => clearInterval(interval);
  }, []);



  const { data: companyData } = useGetCompanyQuery();

  useEffect(() => {
    if (companyData) {
      // Set Document Title
      if (companyData.company) {
        document.title = companyData.company;
      }

      // Set Favicon
      if (companyData.logo) {
        const favicon = document.querySelector('link[rel="icon"]') || document.createElement('link');
        favicon.rel = 'icon';
        favicon.href = `${process.env.REACT_APP_BASE_URL}/${companyData.logo}`;
        if (!document.head.contains(favicon)) {
          document.head.appendChild(favicon);
        }
      }
    }
  }, [companyData]);

  React.useEffect(() => {
    document.body.style.backgroundColor = modes === 'dark' ? '#222222' : '#EDEDED';
  }, [modes]);

  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Public Route: Login */}
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/" />
              ) : (
                <Suspense fallback={<LoadingFallback />}>
                  <Login />
                </Suspense>
              )
            }
          />
          {/* <Route
            path="/register"
            element={
              isAuthenticated ? (
                <Navigate to="/login" />
              ) : (
                <Suspense fallback={<LoadingFallback />}>
                  <Register />
                </Suspense>
              )
            }
          /> */}

          {/* Protected Routes: Main App Layout */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                {/* <UrlProtectedRoute> */}
                <main
                  className={`w-full bg-transparent transition-all duration-150 ease-linear flex`}
                >
                  <div className="w-full">
                    <div className={`sidebar fixed top-0 md:left-0  ${phoneToggle === 'hide' ? '-left-56' : 'left-0'} z-50 `}>
                      <Sidebar />
                    </div>
                    <div
                      className={` content transition-all duration-150 ease-linear w-full ${sideBarCollapes === 'show' ? 'md:pl-[13.8rem]' : 'md:pl-0'
                        }`}
                    >
                      <Routes>
                        <Route path="/" element={<Overview />} />
                        {renderRoutes(settingsRoutes)}
                        {renderRoutes(distributionRoutes)}
                        {renderRoutes(productRoutes)}
                        {renderRoutes(setupRoutes)}
                        {renderRoutes(purchaseRoutes)}
                        {renderRoutes(inventoryRoutes)}
                        {renderRoutes(stocksRoutes)}
                        {renderRoutes(orderBookingRoutes)}
                        {renderRoutes(paymentsRoutes)}
                        {renderRoutes(accountsRoutes)}
                        {renderRoutes(reportsRoutes)}
                      </Routes>
                    </div>
                  </div>
                </main>
                {/* </UrlProtectedRoute> */}
              </ProtectedRoute>
            }
          />
        </Routes>

        {/* Global Print Manager */}
        {printData && (
          <div className="print-only-container">
            <VoucherPrint data={printData} />
          </div>
        )}

        {/* Global Print Styles */}
        <style dangerouslySetInnerHTML={{
          __html: `
          @page {
            size: A4;
            margin: 0;
          }
          @media print {
            body {
              margin: 0;
              -webkit-print-color-adjust: exact;
            }
            .container, .sidebar, .content, main, .no-print, .ProtectedRoute, .Suspense {
              display: none !important;
              visibility: hidden !important;
            }
            #root > *:not(.print-only-container) {
              display: none !important;
            }
            .print-only-container {
              display: block !important;
              visibility: visible !important;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              z-index: 9999;
              margin: 0;
              padding: 0;
            }
          }
          @media screen {
            .print-only-container {
              display: none !important;
            }
          }
        `}} />
      </Suspense>
    </BrowserRouter>
  );
};

export default App;


